import React from 'react';

export const InProgress = (props) => {
    return (
        <div className={`dev__layout app--progress`}>
            <h1>На этапе разработки</h1>
        </div>
    );
}

export default InProgress;